import React from "react";
import { Field } from "redux-form";
import { Button } from "@jauntin/react-ui";
import EmailField from "@gbli-events/common/src/Components/FormElements/EmailField";
import { validators, normalizers } from "@jauntin/utilities";
import { FieldsProps } from "@gbli-events/common/src/Constants/ReduxFormPropTypes";
import { distinctAdditionalEmail } from "./emailDistinctValidation";

const { required, email } = validators;
const { normalizeEmail } = normalizers;

export const MAX_ADDITIONAL_EMAILS = 4;

const AdditionalEmailFields = ({ fields }) => {
  return (
    <div className="additional-email-fields">
      {fields.map((fieldName, index) => (
        <div key={fieldName} className="d-flex align-items-end mb-2 w-100">
          <Field
            name={fieldName}
            component={EmailField}
            validate={[required, email, distinctAdditionalEmail]}
            normalize={normalizeEmail}
            inputClassName="form-control-lg"
            className="mb-0 flex-grow-1 w-100"
            wrapperClassName="w-100"
            labelClassName="w-100"
            label={
              <div className="d-flex justify-content-between align-items-center w-100">
                <label
                  htmlFor={`additionalEmails[${index}]`}
                  className="mb-0 me-2 flex-grow-1"
                >{`Additional Email ${index + 1}`}</label>
                <Button
                  type="button"
                  className="p-0 ms-auto flex-shrink-0 additional-email-fields__remove-button"
                  text={<i className="fas fa-trash"></i>}
                  onClick={() => fields.remove(index)}
                />
              </div>
            }
          />
        </div>
      ))}
      {fields.length < MAX_ADDITIONAL_EMAILS && (
        <Button
          type="button"
          className="btn-link p-0 additional-email-fields__add-button"
          text={
            <>
              <i className="fal fa-plus me-1"></i>
              Add another email
            </>
          }
          onClick={() => fields.push(undefined)}
        />
      )}
    </div>
  );
};

AdditionalEmailFields.propTypes = {
  fields: FieldsProps.isRequired,
};

export default AdditionalEmailFields;
